import { Controller } from "@hotwired/stimulus";

export default class BankAccountDocumentController extends Controller {
  static targets = ["input", "filename"];

  updateFilename() {
    this.filenameTarget.textContent = this.inputTarget.files[0]?.name || "";
  }
}
